import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { SectionHeader } from './ui';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-noronha-petroleum/30" data-id="element-136">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-137">
        <span className="text-lg font-medium text-noronha-text-heading group-hover:text-noronha-emerald transition-colors pr-8" data-id="element-138">
          {question}
        </span>
        <div className="shrink-0 text-noronha-gold" data-id="element-139">
          {isOpen ? <Minus className="w-5 h-5" data-id="element-140" /> : <Plus className="w-5 h-5" data-id="element-141" />}
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-142">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-143">
            <p className="pb-6 text-noronha-text-body leading-relaxed" data-id="element-144">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Qué nivel de certificación se requiere?',
    a: 'Recomendamos nivel Advanced Open Water debido a la profundidad de algunos sitios (como la Corveta V17 a 60m, que requiere certificación técnica o profunda para el fondo, aunque se puede ver desde arriba). Sin embargo, hay excelentes opciones para buceadores Open Water.'
  }, {
    q: '¿Qué equipo debo llevar?',
    a: 'Recomendamos llevar tu equipo personal (máscara, aletas, regulador, BCD y traje de 3mm). Los tanques y plomos están incluidos. Si necesitas alquilar equipo, avísanos con anticipación para gestionarlo en la isla.'
  }, {
    q: '¿Cómo es el clima y la temperatura del agua?',
    a: 'El clima es tropical todo el año. La temperatura del agua ronda los 27°C a 28°C, por lo que un traje de 3mm o incluso lycra es suficiente para la mayoría de los buceadores.'
  }, {
    q: '¿Los vuelos están incluidos?',
    a: 'No, los vuelos internacionales y domésticos no están incluidos. Deberás volar a Recife (REC) o Natal (NAT) y desde allí tomar un vuelo directo a Fernando de Noronha (FEN). Te asesoraremos en la compra.'
  }, {
    q: '¿Qué son las tasas ambientales?',
    a: 'Noronha es un Parque Nacional Marino. Todos los visitantes deben pagar una Tasa de Preservación Ambiental (TPA) por día de estancia, y un ingreso al Parque Nacional (PARNAMAR) válido por 10 días. Estos pagos se realizan online antes de viajar.'
  }, {
    q: '¿Cuál es la política de cancelación?',
    a: 'La seña inicial de USD 500 no es reembolsable. El resto del pago tiene políticas de cancelación flexibles hasta 90 días antes de la fecha de salida. Te enviaremos los términos y condiciones completos al momento de la reserva.'
  }];
  return <section id="faq" className="py-24 md:py-32 bg-noronha-graphite/30" data-id="element-145">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-146">
        <SectionHeader eyebrow="Dudas Comunes" title="Preguntas Frecuentes" className="mb-12" data-id="element-147" />

        <div className="flex flex-col" data-id="element-148">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-149" />)}
        </div>
      </div>
    </section>;
}